import { render } from "./RepairList.vue?vue&type=template&id=46c24a2e&scoped=true"
import script from "./RepairList.vue?vue&type=script&lang=js"
export * from "./RepairList.vue?vue&type=script&lang=js"

import "./RepairList.vue?vue&type=style&index=0&id=46c24a2e&scoped=true&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/tl-demo-web_v2.0.9.4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46c24a2e"]])

export default __exports__